export default "__VITE_ASSET__BceKwhgd__"